import CardDataContainer from "./card-container";
import { hasAccess } from "../../services/access";
import { ACCESS_CONFIG } from "../strings";

// Google Ads click and campaign data of a lead (Asana 1219642275685771).
// Marketing data: shown for SUPER_ADMIN, ADMIN and MARKETING_MANAGER, not
// for AGENT. Leads without googleAds get no block.
export const getGoogleAdsCollection = ({ googleAds, t, emptyValue }) => {
  if (!googleAds || !hasAccess(ACCESS_CONFIG.MARKETING_MANAGER_TIER)) {
    return [];
  }
  const value = (field) => googleAds[field] || emptyValue;
  const idAndName = (idField, nameField) => (
    <div className="border-start border-2">
      <CardDataContainer
        collection={[
          { label: t("googleAdsLead.id"), value: value(idField) },
          { label: t("common.name"), value: value(nameField) }
        ]}
      />
    </div>
  );
  return [
    {
      label: t("googleAdsLead.title"),
      value: (
        <div className="border-start border-2">
          <CardDataContainer
            collection={[
              {
                label: t("googleAdsLead.campaign"),
                value: idAndName("campaignId", "campaignName")
              },
              {
                label: t("googleAdsLead.adgroup"),
                value: idAndName("adgroupId", "adgroupName")
              },
              { label: t("googleAdsLead.keyword"), value: value("keyword") },
              {
                label: t("googleAdsLead.matchtype"),
                value: value("matchtype")
              },
              { label: t("googleAdsLead.device"), value: value("device") },
              { label: t("googleAdsLead.network"), value: value("network") },
              {
                label: t("googleAdsLead.landingPage"),
                value: (
                  <span className="text-break">{value("landingPage")}</span>
                )
              },
              {
                label: t("googleAdsLead.gclid"),
                value: <span className="text-break">{value("gclid")}</span>
              }
            ]}
          />
        </div>
      )
    }
  ];
};
